import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUser,
    faCommentsAlt,
    faBallotCheck,
    faTag,
    faFolder,
    faFolders,
    faDollyFlatbed,
    faRulerCombined,
} from '@fortawesome/pro-light-svg-icons';

const mapping = {
    User: faUser,
    Exchange: faRulerCombined,
    Comments: faCommentsAlt,
    BallotCheck: faBallotCheck,
    Tag: faTag,
    Folder: faFolder,
    Folders: faFolders,
    DollyFlatbed: faDollyFlatbed,
};

export type BackendIconNames = keyof typeof mapping;

type Props = {
    iconName: BackendIconNames;
};

const BackendIcon: React.FC<Props> = (props) => {
    return <FontAwesomeIcon icon={mapping[props.iconName]} />;
};

export default BackendIcon;
